// '<div v-warp>xxx</div>', // appended to body (default)
// '<div v-warp.prepend>xxx</div>', // prepended to body(default)
// '<div v-warp:target>xxx</div>', // appended to #target (getElementById)
// '<div v-warp:target.prepend>xxx</div>', // prepended to #target (getElementById)

export default {
  name: 'warp',
  inserted (el, bindings, vnode) {
    var container = bindings.arg
      ? document.getElementById(bindings.arg)
      : document.body

    if (container) {
      (bindings.modifiers.prepend && container.firstChild)
        ? container.insertBefore(el, container.firstChild)
        : container.appendChild(el)
    } else {
      // eslint-disable-next-line no-console
      console.warn(`Target element id "${bindings.arg}" não existe.`)
    }
  },
  unbind (el) {
    if (el.parentNode) {
      el.parentNode.removeChild(el)
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/Warp.js